import * as React from "react";
import {cx}       from "emotion";

import "./header.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {InternalLink}                             from "@Xpresso/routes/common/components/internal-link";
import {getAbsLink}                               from "@Xpresso/routes/common/get-abs-link";
import {LoadingPanel}                             from "@Xpresso/routes/common/loading-panel/loading-panel";
import {AGENT_LEVEL, BRANCH_LEVEL, COMPANY_LEVEL} from "@Xpresso/routes/common/logic/user-level";

import {mapFullNameAsInitials} from "../../../user-management-route/user-management-card/user-management-card";
import {UserManagementModal}   from "../../../user-management-route/user-management-modal/user-management-modal";

export const Header = ({data: {loading, agent, user, reload,}, branchId, backTo, navBlock, activeTabLink}) => cs(
    consumeContext("routerHistory"),
    ["agentFullName", ({}, next) => next(agent &&
        [agent.agentNameFirst, agent.agentNameMiddle, agent.agentNameLast].filter(Boolean).join(" ")
    )],
    ["query", ({}, next) => next(parseUrlQuery(window.location.search))],
    ({query}, next) => UserManagementModal({
        initShow: query?.['modal'] === "manage",
        branchId,
        reload,
        next,
        baseUrl : activeTabLink,
    }),
    ({agentFullName, routerHistory}) => (
        <div className="header-4we">
            <div className="back-section">
                {InternalLink({
                    className: "back",
                    to: backTo,
                    "xd-qa-type": "link",
                    "xd-qa-name": "Back",
                    navBlock,
                    children: <>
                        <i className="fa fa-chevron-left"/>
                        Back to Users
                    </>,
                })}
            </div>
            {loading ? (
                LoadingPanel({})
            ) : <>
                <div className="headshot-section">
                    <div className={cx("headshot",{inactive: !agent.agentActive})}>
                        {agent?.imageGallery?.headshots[0]?.thumbnailUrl ? (
                            <img src={agent.imageGallery.headshots[0].thumbnailUrl} alt={agentFullName}/>
                        ) : (
                            <div className="headshot-placeholder">{mapFullNameAsInitials({agent: agent})}</div>
                        )}
                    </div>
                </div>
                <div className="name-section">
                    <div className="top">
                        <div className="name" xd-qa-type="label" xd-qa-name="Agent Full Name">
                            {agentFullName}
                        </div>
                        <div
                            className="user-edit"
                            xd-qa-type="link"
                            xd-qa-name="Edit"
                            onClick={async (e)=> {
                                e.preventDefault();
                                if (await navBlock?.block() === true) {
                                    return;
                                }
                                routerHistory.replace(activeTabLink + '&modal=manage&menu=general');
                            }}
                            >
                                Edit
                        </div>
                    </div>

                    {(!agent.agentActive || (user.loginLevel !== AGENT_LEVEL)) && (
                        <div className="badges">
                            {user?.loginLevel === COMPANY_LEVEL ? (
                                <span xd-qa-type="badge" xd-qa-name="Company Admin" className="badge company-admin-badge">Company Admin</span>
                            ) : user?.loginLevel === BRANCH_LEVEL && (
                                <span xd-qa-type="badge" xd-qa-name="Office Admin" className="badge office-admin-badge">Office Admin</span>
                            )}

                            {!agent?.agentActive && <span xd-qa-type="badge" xd-qa-name="Inactive" className="badge inactive-badge">Inactive</span>}
                        </div>
                    )}
                </div>
            </>}
        </div>
    ),
);
